import * as React from 'react';
import './conferenceInformationField.scss';
import { FieldProps } from '../metadataFormField';
import { FieldGroup } from '../FieldGroup/fieldGroup';
import { Arrow } from 'rcd-cpp-ui/ui/icon/Arrow';
import { cn, formatDate } from '../../../utils';
import { useSelector } from '../../../utils/useSelector';
import * as ItemTypeIcon from '../../Icon/itemTypeIcon';
import { ItemType } from '../../../enums/ItemType';

export const ConferenceInformationField = (props: FieldProps) => {
  const selectedViewId = useSelector(s => s?.view?.selected?.props?.refId);

  const { data } = props;
  const conferenceSeriesUnsorted = data?.conferenceInformation?.props;
  const conferenceSeries = data?.conferenceInformation?.conferenceSeries;
  const globalSubmissionRefId =
    data?.conferenceInformation?.globalSubmissionRefId;

  const conferenceSeriesList = conferenceSeriesUnsorted
    ? [...conferenceSeriesUnsorted].sort((a, b) =>
        a.title.localeCompare(b.title)
      )
    : [];
  const FormIcon = ItemTypeIcon['globalSubmission'];

  return (
    <FieldGroup {...props} value={null} disabled={false} componentRight={null}>
      <div>
        <div className="conference-information-header">
          {!!conferenceSeries ? (
            <div className="conference-series">{conferenceSeries}</div>
          ) : (
            <div className="dashes">--</div>
          )}
          {data?.props?.itemType == ItemType.conferenceSession &&
            !!globalSubmissionRefId && (
              <div className="global-submission-link">
                <FormIcon />
                <a
                  target="_blank"
                  href={`?v=${selectedViewId}&id=${globalSubmissionRefId}`}
                >
                  Global Submission
                </a>
              </div>
            )}
        </div>
        {conferenceSeriesList.length > 0 &&
          conferenceSeriesList.map(props => {
            if (props.code == null) return null;
            const selected = props?.conferenceSessionId == data?.props?.refId;
            return (
              <ConferenceSeriesCard
                key={props.code}
                selected={selected}
                {...props}
              />
            );
          })}
      </div>
    </FieldGroup>
  );
};

interface ConferenceSeriesCardCardProps {
  title: string;
  code: string;
  conferenceChair: string;
  date: Date;
  sessionType: string;
  leadAuthor: string;
  locations: string;
  status: string;
  conferenceSessionId: string;
  selected?: boolean;
}
const ConferenceSeriesCard = ({
  title,
  code,
  conferenceChair,
  date,
  sessionType,
  leadAuthor,
  locations,
  status,
  conferenceSessionId,
  selected
}: ConferenceSeriesCardCardProps) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const selectedViewId = useSelector(s => s?.view?.selected?.props?.refId);

  return (
    <div className="conference-series-card">
      <div
        className={cn('conference-series-header', {
          collapse: !isExpanded
        })}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Arrow direction={isExpanded ? 'down' : 'right'} type="solid" />
        <div className="conference-series-text">
          <div className="conference-series-title">
            {title || '<Title not defined>'}
          </div>
          <div className="conference-series-code">
            {conferenceSessionId && selectedViewId ? (
              <a
                target="_blank"
                href={`?v=${selectedViewId}&id=${conferenceSessionId}`}
              >
                {code || '--'}
              </a>
            ) : (
              code || '--'
            )}
          </div>
          {selected && <span className="selected">Selected</span>}
        </div>
        <div className="conference-series-status">{status || '--'}</div>
      </div>
      {isExpanded && (
        <ConferenceSeriesFieldValue
          conferenceChair={conferenceChair}
          date={date}
          sessionType={sessionType}
          leadAuthor={leadAuthor}
          locations={locations}
        />
      )}
    </div>
  );
};

type ConferenceSeriesFieldValueProps = {
  conferenceChair: string;
  date: Date;
  sessionType: string;
  leadAuthor: string;
  locations: string;
};

const ConferenceSeriesFieldValue = ({
  conferenceChair,
  date,
  sessionType,
  leadAuthor,
  locations
}: ConferenceSeriesFieldValueProps) => {
  return (
    <div className="conference-series-container">
      <div className="conference-series-col">
        <div>Chair: {conferenceChair || `--`}</div>
        <div>Session Type: {sessionType || `--`}</div>
        <div>Locations: {locations || `--`}</div>
      </div>
      <div className="conference-series-col">
        <div>Lead Author: {leadAuthor || `--`}</div>
        <div>Date: {formatDate(date) || `--`}</div>
      </div>
    </div>
  );
};
